import { View } from '@gluestack-ui/themed'
import React, { FunctionComponent } from 'react'
import { StatusBar, StatusBarStyle, StyleProp, StyleSheet, ViewStyle } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { useSelector } from 'react-redux'
import { themeSelector } from '../../../redux/theme/selector'
import { theme as defaultTheme } from '../../../theme'

type HeaderProps = {
  androidStatusBarColor?: string
  transparent?: boolean
  translucent?: boolean
  iosBarStyle?: string
  safeAreaTop?: boolean
  style?: StyleProp<ViewStyle>
  children?: React.ReactNode
}

export const Header: FunctionComponent<HeaderProps> = ({ androidStatusBarColor, style, transparent, translucent, iosBarStyle, children, safeAreaTop = true }) => {
  const theme = useSelector(themeSelector)
  const toolbarBg = theme?.toolbarDefaultBg || defaultTheme.colors.blue

  return (
    <SafeAreaView edges={safeAreaTop ? ['top'] : []} style={[style, { backgroundColor: transparent ? undefined : theme?.toolbarDefaultBg }]}>
      <StatusBar
        backgroundColor={androidStatusBarColor || toolbarBg}
        barStyle={(iosBarStyle || 'light-content') as StatusBarStyle}
        translucent={transparent ? true : translucent}
      />
      <View style={styles.header}>{children}</View>
    </SafeAreaView>
  )
}

const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    paddingHorizontal: defaultTheme.padding.x1,
    paddingVertical: defaultTheme.padding.x2,
  },
})
